var _defs, _g, _g2, _g3, _path, _path2, _path3, _g4, _path4, _g5, _path5, _g6, _path6, _g7, _path7, _g8, _g9, _path8, _g10, _g11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQ4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 408.9,
    height: 169.106,
    viewBox: "0 0 408.9 169.106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3542",
    "data-name": "Tracciato 3542",
    d: "M36.439,45.7c-.008,2.793-1,4.758-2.585,5.682l9.038-5.223c1.593-.925,2.581-2.891,2.587-5.683Z",
    transform: "translate(-33.854 -40.472)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3544",
    "data-name": "Tracciato 3544",
    d: "M22.473.6,13.432,5.824c1.613-.935,3.844-.806,6.305.615l9.041-5.223A8.069,8.069,0,0,0,24.805,0a4.589,4.589,0,0,0-2.332.6",
    transform: "translate(-13.432)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3550",
    "data-name": "Tracciato 3550",
    d: "M30.068,13.344c4.9,2.829,8.868,9.7,8.853,15.331L47.96,23.45c.016-5.63-3.953-12.5-8.852-15.331Z",
    transform: "translate(-30.068 -8.119)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_275",
    "data-name": "Rettangolo 275",
    width: 68.079,
    height: 153.811,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_274",
    "data-name": "Rettangolo 274",
    width: 26.081,
    height: 20.047,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_265",
    "data-name": "Rettangolo 265",
    width: 2.559,
    height: 8.521,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3554",
    "data-name": "Tracciato 3554",
    d: "M22.963,82.252l-.015-4.965c0,1.286-.847,2.576-2.545,3.557l.013,4.964c1.7-.979,2.55-2.269,2.546-3.555",
    transform: "translate(-20.404 -77.287)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_267",
    "data-name": "Rettangolo 267",
    width: 8.832,
    height: 10.056,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_268",
    "data-name": "Rettangolo 268",
    width: 14.718,
    height: 9.944,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3560",
    "data-name": "Tracciato 3560",
    d: "M5.993,80.431,6.006,85.4c0,1.273.842,2.543,2.515,3.514a13.408,13.408,0,0,0,12.189,0L20.7,83.947a13.417,13.417,0,0,1-12.189,0C6.834,82.974,6,81.7,5.993,80.431",
    transform: "translate(-5.993 -80.431)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_269",
    "data-name": "Rettangolo 269",
    width: 1.756,
    height: 7.966,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_270",
    "data-name": "Rettangolo 270",
    width: 10.784,
    height: 6.943,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_271",
    "data-name": "Rettangolo 271",
    width: 2.205,
    height: 5.887,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_272",
    "data-name": "Rettangolo 272",
    width: 26.067,
    height: 15.082,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3569",
    "data-name": "Tracciato 3569",
    d: "M10.851,93.5c0,1.3.857,2.608,2.581,3.606a13.624,13.624,0,0,0,12.356,0c1.689-.983,2.535-2.269,2.54-3.555l.038-42.115c0,1.288-.849,2.572-2.54,3.555a13.614,13.614,0,0,1-12.356,0c-1.724-1-2.582-2.3-2.579-3.6Z",
    transform: "translate(-10.851 -51.387)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_285",
    "data-name": "Rettangolo 285",
    width: 26.082,
    height: 20.047,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_276",
    "data-name": "Rettangolo 276",
    width: 2.56,
    height: 8.521,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3573",
    "data-name": "Tracciato 3573",
    d: "M35.185,89.962,35.171,85c0,1.288-.847,2.576-2.545,3.557l.013,4.965c1.7-.981,2.55-2.27,2.546-3.557",
    transform: "translate(-32.626 -84.997)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3579",
    "data-name": "Tracciato 3579",
    d: "M18.215,88.142l.013,4.965c0,1.271.842,2.541,2.515,3.514a13.418,13.418,0,0,0,12.189,0l-.015-4.965a13.418,13.418,0,0,1-12.189,0c-1.671-.973-2.51-2.243-2.514-3.514",
    transform: "translate(-18.215 -88.142)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-27"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_280",
    "data-name": "Rettangolo 280",
    width: 1.757,
    height: 7.966,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_281",
    "data-name": "Rettangolo 281",
    width: 10.785,
    height: 6.943,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3588",
    "data-name": "Tracciato 3588",
    d: "M23.073,101.21c0,1.306.857,2.61,2.581,3.6a13.614,13.614,0,0,0,12.356,0c1.691-.981,2.535-2.267,2.54-3.553l.038-42.113c0,1.286-.849,2.572-2.538,3.553a13.618,13.618,0,0,1-12.358,0c-1.724-.994-2.582-2.3-2.579-3.6Z",
    transform: "translate(-23.073 -59.097)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-33"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_299",
    "data-name": "Rettangolo 299",
    width: 95.095,
    height: 95.095,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3610",
    "data-name": "Tracciato 3610",
    d: "M95.1,47.55A47.548,47.548,0,1,0,47.546,95.1,47.55,47.55,0,0,0,95.1,47.55",
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.35,
    cy: 0.285,
    r: 0.651,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.074,
    stopColor: "#e9e9e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#a1a1a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.559,
    stopColor: "#686867"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.755,
    stopColor: "#3f3f3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.908,
    stopColor: "#262624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d1d1b"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-37"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_297",
    "data-name": "Rettangolo 297",
    width: 90.338,
    height: 65.113,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_290",
    "data-name": "Rettangolo 290",
    width: 11.162,
    height: 17.326,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-39"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_291",
    "data-name": "Rettangolo 291",
    width: 9.29,
    height: 8.494,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_292",
    "data-name": "Rettangolo 292",
    width: 3.779,
    height: 8.218,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_293",
    "data-name": "Rettangolo 293",
    width: 3.742,
    height: 4.202,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_294",
    "data-name": "Rettangolo 294",
    width: 26.917,
    height: 37.549,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-43"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_295",
    "data-name": "Rettangolo 295",
    width: 18.486,
    height: 20.93,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_296",
    "data-name": "Rettangolo 296",
    width: 9.909,
    height: 10.354,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Domanda_3.4",
    "data-name": "Domanda 3.4",
    transform: "translate(14.213 -103)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_703",
    "data-name": "Raggruppa 703",
    transform: "translate(246.796 251.995) rotate(179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_722",
    "data-name": "Raggruppa 722",
    transform: "translate(-47.792 16.647)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3778",
    "data-name": "Tracciato 3778",
    d: "M11.055,70.787C-7.6,63.706,2.288,46.6,5.481,31.059c.882-4.3,8.185-8.432,21.18-11.332,28.361-6.321,60.375-2.1,88.142,1.373,22.026,2.754,49.858,5.047,70.19,1.6,14.839-2.515,19.951-7.183,27.314-11.214,9.484-5.19,26.144-10.092,48.9-11.238,28.589-1.44,56.913,3.6,71.46,9.8s19.179,13.436,27.584,20.277c12.008,9.783,32.027,18.934,41.8,28.864s7.414,21.43-20.614,29c-22.072,5.958-56.758,8.435-89.57,8.007s-64.152-3.443-93.557-7.034c-23.515-2.87-47.4-6.213-73.671-6.365-17.454-.1-52.934.142-68.715-1.688-17.36-2.013-34.463-6.368-44.87-10.32",
    transform: "translate(-100.734 18.414)",
    fill: "#3f3d94"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_521",
    "data-name": "Raggruppa 521",
    transform: "translate(276.921 118.296)"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_430",
    "data-name": "Raggruppa 430",
    transform: "translate(55.257 66.06)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_429",
    "data-name": "Raggruppa 429",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3540",
    "data-name": "Tracciato 3540",
    d: "M35.458,45.7,44.5,40.471c0,.359-.018.7-.051,1.033l-9.039,5.225c.033-.33.049-.676.051-1.033",
    transform: "translate(-32.872 -40.473)",
    fill: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3541",
    "data-name": "Tracciato 3541",
    d: "M36.389,46.329,45.429,41.1a5.726,5.726,0,0,1-2.535,4.65l-9.041,5.223a5.722,5.722,0,0,0,2.536-4.649",
    transform: "translate(-33.855 -40.072)",
    fill: "#999"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_432",
    "data-name": "Raggruppa 432",
    transform: "translate(21.924 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_431",
    "data-name": "Raggruppa 431",
    transform: "translate(0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3543",
    "data-name": "Tracciato 3543",
    d: "M13.433,5.824,22.472.6c1.613-.937,3.844-.806,6.305.615L19.738,6.439c-2.463-1.422-4.693-1.552-6.305-.615",
    transform: "translate(-13.431 0)",
    fill: "#999"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3545",
    "data-name": "Tracciato 3545",
    d: "M17.3,5.968,26.335.744l10.43,6.023L27.725,11.99Z",
    transform: "translate(10.935 0.471)",
    fill: "#939393"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3546",
    "data-name": "Tracciato 3546",
    d: "M35.526,22.736l-.088,37.476,9.041-5.225.088-37.476Z",
    transform: "translate(22.405 11.072)",
    fill: "#afafaf"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3547",
    "data-name": "Tracciato 3547",
    d: "M23.686,9.658l9.039-5.225,10.419,6.015L34.1,15.673Z",
    transform: "translate(14.975 2.804)",
    fill: "#939393"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_434",
    "data-name": "Raggruppa 434",
    transform: "translate(49.078 13.253)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_433",
    "data-name": "Raggruppa 433",
    transform: "translate(0)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3548",
    "data-name": "Tracciato 3548",
    d: "M30.068,13.343l9.041-5.225a16.918,16.918,0,0,1,5.05,4.737l-9.041,5.223a16.914,16.914,0,0,0-5.05-4.735",
    transform: "translate(-30.068 -8.12)",
    fill: "#999"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3549",
    "data-name": "Tracciato 3549",
    d: "M33.162,16.245,42.2,11.02a18.947,18.947,0,0,1,3.8,10.6l-9.039,5.225a18.949,18.949,0,0,0-3.8-10.6",
    transform: "translate(-28.112 -6.285)",
    fill: "#b3b3b3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_474",
    "data-name": "Raggruppa 474",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_473",
    "data-name": "Raggruppa 473",
    clipPath: "url(#clip-path-4)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3551",
    "data-name": "Tracciato 3551",
    d: "M41.624,16.452c4.9,2.829,8.868,9.7,8.852,15.331l-.087,37.476c-.016,5.63-4.01,7.892-8.91,5.063L31.06,68.307,20.63,62.286c-4.9-2.829-8.855-9.682-8.84-15.312L11.878,9.5c.016-5.63,4-7.911,8.9-5.084l10.43,6.023Z",
    transform: "translate(7.454 2.024)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_472",
    "data-name": "Raggruppa 472",
    transform: "translate(9.781 121.179)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_471",
    "data-name": "Raggruppa 471"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_470",
    "data-name": "Raggruppa 470",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_469",
    "data-name": "Raggruppa 469",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_468",
    "data-name": "Raggruppa 468"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_467",
    "data-name": "Raggruppa 467",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_437",
    "data-name": "Raggruppa 437",
    transform: "translate(23.522 4.971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_436",
    "data-name": "Raggruppa 436",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_435",
    "data-name": "Raggruppa 435",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3552",
    "data-name": "Tracciato 3552",
    d: "M22.964,82.251l-.016-4.965c0,1.286-.845,2.576-2.545,3.557l.016,4.964c1.7-.979,2.546-2.269,2.545-3.555",
    transform: "translate(-20.404 -77.287)",
    fill: "#002747"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_443",
    "data-name": "Raggruppa 443",
    transform: "translate(23.523 4.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_442",
    "data-name": "Raggruppa 442",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_440",
    "data-name": "Raggruppa 440",
    transform: "translate(-0.001 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_439",
    "data-name": "Raggruppa 439"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_438",
    "data-name": "Raggruppa 438",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3553",
    "data-name": "Tracciato 3553",
    d: "M20.4,80.843l.015,4.965c1.7-.981,2.548-2.269,2.545-3.557l-.015-4.965c0,1.288-.845,2.576-2.545,3.557",
    transform: "translate(-20.404 -77.287)",
    fill: "#002747"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_447",
    "data-name": "Raggruppa 447",
    transform: "translate(14.704 8.527)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_446",
    "data-name": "Raggruppa 446"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_445",
    "data-name": "Raggruppa 445",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3555",
    "data-name": "Tracciato 3555",
    d: "M15,84.556l.015,4.965,8.817-5.091-.015-4.965Z",
    transform: "translate(-15.001 -79.465)",
    fill: "#002747"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_450",
    "data-name": "Raggruppa 450",
    transform: "translate(0 10.103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_449",
    "data-name": "Raggruppa 449"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_448",
    "data-name": "Raggruppa 448",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3556",
    "data-name": "Tracciato 3556",
    d: "M5.993,80.431,6.008,85.4c0,1.271.841,2.541,2.514,3.514a13.408,13.408,0,0,0,12.189,0L20.7,83.945a13.411,13.411,0,0,1-12.191,0C6.835,82.974,6,81.7,5.993,80.431",
    transform: "translate(-5.993 -80.431)",
    fill: "#002747"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_462",
    "data-name": "Raggruppa 462",
    transform: "translate(0.001 10.103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_461",
    "data-name": "Raggruppa 461",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_453",
    "data-name": "Raggruppa 453",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_452",
    "data-name": "Raggruppa 452"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_451",
    "data-name": "Raggruppa 451",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3557",
    "data-name": "Tracciato 3557",
    d: "M5.993,80.431,6.008,85.4a3.863,3.863,0,0,0,1.742,3l-.013-4.964a3.875,3.875,0,0,1-1.743-3",
    transform: "translate(-5.993 -80.431)",
    fill: "#002747"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_456",
    "data-name": "Raggruppa 456",
    transform: "translate(1.742 3.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_455",
    "data-name": "Raggruppa 455"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_454",
    "data-name": "Raggruppa 454",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3558",
    "data-name": "Tracciato 3558",
    d: "M7.06,82.27l.015,4.965a7.424,7.424,0,0,0,.77.513,13.568,13.568,0,0,0,10,.922l-.013-4.964a13.575,13.575,0,0,1-10-.924,7.452,7.452,0,0,1-.772-.513",
    transform: "translate(-7.06 -82.269)",
    fill: "#002747"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_459",
    "data-name": "Raggruppa 459",
    transform: "translate(12.512 3.514)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_458",
    "data-name": "Raggruppa 458"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_457",
    "data-name": "Raggruppa 457",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3559",
    "data-name": "Tracciato 3559",
    d: "M13.659,83.506l.015,4.965a10.138,10.138,0,0,0,2.19-.922l-.015-4.965a10.139,10.139,0,0,1-2.19.922",
    transform: "translate(-13.659 -82.584)",
    fill: "#002747"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_466",
    "data-name": "Raggruppa 466",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_465",
    "data-name": "Raggruppa 465"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_464",
    "data-name": "Raggruppa 464",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3561",
    "data-name": "Tracciato 3561",
    d: "M8.537,80.792c-3.384,1.954-3.392,5.114-.029,7.066a13.408,13.408,0,0,0,12.189,0l8.817-5.089c3.374-1.949,3.4-5.109.039-7.061a13.448,13.448,0,0,0-12.2-.007Z",
    transform: "translate(-5.993 -74.241)",
    fill: "#00447d"
  }))))))))))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3562",
    "data-name": "Tracciato 3562",
    d: "M28.365,51.437,28.326,93.55c0,1.288-.849,2.572-2.538,3.555a13.628,13.628,0,0,1-12.358,0c-1.722-1-2.582-2.3-2.579-3.6l.039-42.115c0,1.3.857,2.61,2.579,3.6a13.614,13.614,0,0,0,12.356,0c1.691-.981,2.536-2.267,2.54-3.553",
    transform: "translate(6.86 32.488)",
    fill: "#ededed"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_476",
    "data-name": "Raggruppa 476",
    transform: "translate(17.711 83.876)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_475",
    "data-name": "Raggruppa 475",
    transform: "translate(0)",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3563",
    "data-name": "Tracciato 3563",
    d: "M21.714,51.417,21.675,93.53a3.111,3.111,0,0,1-.3,1.319l.038-42.113a3.113,3.113,0,0,0,.305-1.319",
    transform: "translate(-4.2 -51.368)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3564",
    "data-name": "Tracciato 3564",
    d: "M21.85,52.225l-.038,42.113A4.5,4.5,0,0,1,20.672,95.8l.038-42.113a4.47,4.47,0,0,0,1.141-1.459",
    transform: "translate(-4.642 -50.857)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3565",
    "data-name": "Tracciato 3565",
    d: "M22.926,53.119l-.039,42.113a6.97,6.97,0,0,1-1.094.777,11.724,11.724,0,0,1-4.624,1.4L17.208,55.3a11.683,11.683,0,0,0,4.622-1.4,6.982,6.982,0,0,0,1.1-.775",
    transform: "translate(-6.857 -50.292)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3566",
    "data-name": "Tracciato 3566",
    d: "M18.274,54.454l-.038,42.113a15.063,15.063,0,0,1-2.754.031l.039-42.113a15.045,15.045,0,0,0,2.752-.031",
    transform: "translate(-7.923 -49.448)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3567",
    "data-name": "Tracciato 3567",
    d: "M16.461,54.631l-.039,42.113a13.88,13.88,0,0,1-2.427-.408l.038-42.113a13.9,13.9,0,0,0,2.429.408",
    transform: "translate(-8.863 -49.594)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3568",
    "data-name": "Tracciato 3568",
    d: "M16.021,56.016l-.038,42.113A10.439,10.439,0,0,1,13.431,97.1c-1.724-1-2.584-2.3-2.579-3.6l.038-42.113c0,1.3.857,2.608,2.579,3.6a10.468,10.468,0,0,0,2.553,1.027",
    transform: "translate(-10.85 -51.387)",
    fill: "#ededed"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_516",
    "data-name": "Raggruppa 516",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_515",
    "data-name": "Raggruppa 515",
    clipPath: "url(#clip-path-4)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3570",
    "data-name": "Tracciato 3570",
    d: "M25.771,49.783c3.423,1.977,3.441,5.181.041,7.157a13.618,13.618,0,0,1-12.358,0c-3.423-1.977-3.441-5.181-.039-7.157a13.614,13.614,0,0,1,12.356,0",
    transform: "translate(6.876 30.538)",
    fill: "#ededed"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_514",
    "data-name": "Raggruppa 514",
    transform: "translate(29.731 133.764)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_513",
    "data-name": "Raggruppa 513"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_512",
    "data-name": "Raggruppa 512",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_511",
    "data-name": "Raggruppa 511",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_510",
    "data-name": "Raggruppa 510"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_509",
    "data-name": "Raggruppa 509",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_479",
    "data-name": "Raggruppa 479",
    transform: "translate(23.522 4.971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_478",
    "data-name": "Raggruppa 478",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_477",
    "data-name": "Raggruppa 477",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3571",
    "data-name": "Tracciato 3571",
    d: "M35.185,89.962,35.171,85c0,1.288-.845,2.576-2.545,3.557l.015,4.965c1.7-.981,2.548-2.27,2.545-3.557",
    transform: "translate(-32.625 -84.997)",
    fill: "#002747"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_485",
    "data-name": "Raggruppa 485",
    transform: "translate(23.523 4.971)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_484",
    "data-name": "Raggruppa 484",
    transform: "translate(0)",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_482",
    "data-name": "Raggruppa 482",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_481",
    "data-name": "Raggruppa 481"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_480",
    "data-name": "Raggruppa 480",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3572",
    "data-name": "Tracciato 3572",
    d: "M32.626,88.552l.015,4.965c1.7-.981,2.548-2.269,2.545-3.557L35.171,85c0,1.286-.845,2.574-2.545,3.555",
    transform: "translate(-32.625 -84.997)",
    fill: "#002747"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_489",
    "data-name": "Raggruppa 489",
    transform: "translate(14.704 8.527)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_488",
    "data-name": "Raggruppa 488"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_487",
    "data-name": "Raggruppa 487",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3574",
    "data-name": "Tracciato 3574",
    d: "M27.223,92.266l.015,4.965,8.817-5.091-.015-4.965Z",
    transform: "translate(-27.223 -87.175)",
    fill: "#002747"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_492",
    "data-name": "Raggruppa 492",
    transform: "translate(0 10.103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_491",
    "data-name": "Raggruppa 491"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_490",
    "data-name": "Raggruppa 490",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3575",
    "data-name": "Tracciato 3575",
    d: "M18.215,88.141l.015,4.965c0,1.271.842,2.541,2.514,3.514a13.418,13.418,0,0,0,12.189,0l-.013-4.965a13.411,13.411,0,0,1-12.191,0c-1.671-.971-2.51-2.243-2.514-3.514",
    transform: "translate(-18.215 -88.141)",
    fill: "#002747"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_504",
    "data-name": "Raggruppa 504",
    transform: "translate(0 10.105)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_503",
    "data-name": "Raggruppa 503",
    clipPath: "url(#clip-path-26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_495",
    "data-name": "Raggruppa 495",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_494",
    "data-name": "Raggruppa 494",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_493",
    "data-name": "Raggruppa 493",
    clipPath: "url(#clip-path-27)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3576",
    "data-name": "Tracciato 3576",
    d: "M18.215,88.141l.015,4.965a3.863,3.863,0,0,0,1.742,3l-.013-4.965a3.87,3.87,0,0,1-1.743-3",
    transform: "translate(-18.215 -88.141)",
    fill: "#002747"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_498",
    "data-name": "Raggruppa 498",
    transform: "translate(1.742 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_497",
    "data-name": "Raggruppa 497"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_496",
    "data-name": "Raggruppa 496",
    clipPath: "url(#clip-path-28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3577",
    "data-name": "Tracciato 3577",
    d: "M19.282,89.98l.015,4.965a7.427,7.427,0,0,0,.77.513,13.569,13.569,0,0,0,10,.922l-.013-4.965a13.575,13.575,0,0,1-10-.921,7.461,7.461,0,0,1-.772-.514",
    transform: "translate(-19.282 -89.98)",
    fill: "#002747"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_501",
    "data-name": "Raggruppa 501",
    transform: "translate(12.513 3.513)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_500",
    "data-name": "Raggruppa 500",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_499",
    "data-name": "Raggruppa 499",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3578",
    "data-name": "Tracciato 3578",
    d: "M25.881,91.216l.015,4.965a10.137,10.137,0,0,0,2.19-.922l-.015-4.965a10.137,10.137,0,0,1-2.19.922",
    transform: "translate(-25.881 -90.294)",
    fill: "#002747"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_508",
    "data-name": "Raggruppa 508",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_507",
    "data-name": "Raggruppa 507"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_506",
    "data-name": "Raggruppa 506",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3580",
    "data-name": "Tracciato 3580",
    d: "M20.76,88.5c-3.384,1.954-3.393,5.114-.033,7.066a13.411,13.411,0,0,0,12.191,0l8.817-5.091c3.374-1.947,3.4-5.107.039-7.059a13.448,13.448,0,0,0-12.2-.007Z",
    transform: "translate(-18.215 -81.951)",
    fill: "#00447d"
  }))))))))))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3581",
    "data-name": "Tracciato 3581",
    d: "M40.587,59.146l-.039,42.113c0,1.288-.849,2.572-2.538,3.555a13.628,13.628,0,0,1-12.358,0c-1.722-1-2.582-2.3-2.579-3.6L23.112,59.1c0,1.3.857,2.608,2.579,3.6a13.614,13.614,0,0,0,12.356,0c1.691-.981,2.536-2.266,2.54-3.553",
    transform: "translate(14.587 37.363)",
    fill: "#ededed"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_518",
    "data-name": "Raggruppa 518",
    transform: "translate(37.66 96.46)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_517",
    "data-name": "Raggruppa 517",
    transform: "translate(0)",
    clipPath: "url(#clip-path-31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3582",
    "data-name": "Tracciato 3582",
    d: "M33.936,59.127,33.9,101.24a3.111,3.111,0,0,1-.3,1.319l.038-42.113a3.113,3.113,0,0,0,.305-1.319",
    transform: "translate(-16.422 -59.078)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3583",
    "data-name": "Tracciato 3583",
    d: "M34.073,59.935l-.039,42.113a4.486,4.486,0,0,1-1.139,1.459l.038-42.113a4.492,4.492,0,0,0,1.141-1.459",
    transform: "translate(-16.863 -58.567)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3584",
    "data-name": "Tracciato 3584",
    d: "M35.148,60.829l-.038,42.113a7.175,7.175,0,0,1-1.1.777,11.724,11.724,0,0,1-4.624,1.4l.039-42.113a11.709,11.709,0,0,0,4.622-1.4,6.981,6.981,0,0,0,1.1-.775",
    transform: "translate(-19.079 -58.002)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3585",
    "data-name": "Tracciato 3585",
    d: "M30.5,62.164l-.039,42.113a15.188,15.188,0,0,1-2.752.033L27.744,62.2a15.045,15.045,0,0,0,2.752-.031",
    transform: "translate(-20.145 -57.158)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3586",
    "data-name": "Tracciato 3586",
    d: "M28.685,62.341l-.039,42.113a13.873,13.873,0,0,1-2.429-.408l.038-42.113a13.916,13.916,0,0,0,2.43.408",
    transform: "translate(-21.085 -57.304)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3587",
    "data-name": "Tracciato 3587",
    d: "M28.243,63.726l-.038,42.113a10.44,10.44,0,0,1-2.553-1.025c-1.724-.994-2.584-2.3-2.579-3.6L23.112,59.1c0,1.3.857,2.608,2.579,3.6a10.465,10.465,0,0,0,2.553,1.025",
    transform: "translate(-23.072 -59.097)",
    fill: "#ededed"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_520",
    "data-name": "Raggruppa 520",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_519",
    "data-name": "Raggruppa 519",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3589",
    "data-name": "Tracciato 3589",
    d: "M37.993,57.494c3.423,1.977,3.441,5.181.041,7.157a13.618,13.618,0,0,1-12.358,0c-3.423-1.977-3.441-5.181-.041-7.157a13.618,13.618,0,0,1,12.358,0",
    transform: "translate(14.603 35.413)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3590",
    "data-name": "Tracciato 3590",
    d: "M14.917,51.763A7.372,7.372,0,0,1,2.777,43.4l12.371-17.95a7.373,7.373,0,0,1,12.141,8.368Z",
    transform: "translate(0.932 14.073)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3591",
    "data-name": "Tracciato 3591",
    d: "M14.709,63.773A7.372,7.372,0,0,1,.037,62.316L2.192,40.625a7.372,7.372,0,1,1,14.672,1.456Z",
    transform: "translate(0 21.484)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3592",
    "data-name": "Tracciato 3592",
    d: "M48.561,83.477c-.131,2.295-.25,4.342-.348,6-.186,2.971-.317,4.766-.317,4.766l-36.653-19.5s-.163-2.665-.338-6.81c-.065-1.851-.14-3.983-.2-6.312-.315-12.392-.229-30.191,2.481-37.73,1.273-3.524,15.624-.271,15.624-.271S48.007,34.486,48.909,39.772c1.361,8.029.4,30.257-.348,43.7",
    transform: "translate(6.691 14.074)",
    fill: "#ededed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3593",
    "data-name": "Tracciato 3593",
    d: "M48.512,68.227c-.131,2.295.02,4.427-.078,6.091l-20.2-11.6L10.857,52.692c-.065-1.851-.14-3.983-.2-6.312L28.232,56.521Z",
    transform: "translate(6.74 29.323)",
    fill: "#003766"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3594",
    "data-name": "Tracciato 3594",
    d: "M26.3,36.535v8.432c2.017,1.165,3.651.22,3.651-2.107A8.068,8.068,0,0,0,26.3,36.535",
    transform: "translate(16.63 23.099)",
    fill: "#d83736"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3595",
    "data-name": "Tracciato 3595",
    d: "M24.066,38.836a8.075,8.075,0,0,0,3.651,6.325V36.727c-2.016-1.164-3.651-.22-3.651,2.109",
    transform: "translate(15.215 22.905)",
    fill: "#ff4140"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3596",
    "data-name": "Tracciato 3596",
    d: "M31.521,46.968l-7.454-4.3v3.242l7.454,4.3Z",
    transform: "translate(15.215 26.974)",
    fill: "#00447d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3597",
    "data-name": "Tracciato 3597",
    d: "M24.066,44.649v3.24l7.454,4.3v-3.24Z",
    transform: "translate(15.215 28.229)",
    fill: "#003766"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3598",
    "data-name": "Tracciato 3598",
    d: "M15.033,30.136v4.04l3.726,2.151v-4.04Z",
    transform: "translate(9.504 19.053)",
    fill: "#ff4140"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3599",
    "data-name": "Tracciato 3599",
    d: "M21.043,33.606l-3.726-2.151v4.04l3.726,2.151Z",
    transform: "translate(10.948 19.887)",
    fill: "#d83736"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3600",
    "data-name": "Tracciato 3600",
    d: "M22.487,39.3,15.033,35V33.54l7.454,4.3Z",
    transform: "translate(9.504 21.205)",
    fill: "#00447d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3601",
    "data-name": "Tracciato 3601",
    d: "M42.464,69.909a8.437,8.437,0,0,1-1.17.088,7.694,7.694,0,0,1-7.6-6.537l-3.434-22.5a7.7,7.7,0,0,1,6.459-8.767,8.716,8.716,0,0,1,1.17-.088,7.7,7.7,0,0,1,7.6,6.537l.067.4.795,5.279,2.561,16.827a7.693,7.693,0,0,1-6.447,8.767",
    transform: "translate(19.077 20.297)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3602",
    "data-name": "Tracciato 3602",
    d: "M43.8,77.793a7.7,7.7,0,1,1-14.87-3.984L34.82,51.826A7.7,7.7,0,1,1,49.69,55.81Z",
    transform: "translate(18.123 29.158)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3603",
    "data-name": "Tracciato 3603",
    d: "M.029,51.418a7.368,7.368,0,0,0,14.666,1.415Z",
    transform: "translate(0.002 32.508)",
    fill: "#002747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3604",
    "data-name": "Tracciato 3604",
    d: "M34.372,72.492A7.7,7.7,0,0,0,43.8,67.049l0-.01L28.919,63.112a7.7,7.7,0,0,0,5.453,9.38",
    transform: "translate(18.124 39.902)",
    fill: "#002747"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3605",
    "data-name": "Tracciato 3605",
    d: "M51.467,23.955A20.755,20.755,0,1,1,30.713,3.2,20.754,20.754,0,0,1,51.467,23.955",
    transform: "translate(6.296 2.025)",
    fill: "#dcdcdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3606",
    "data-name": "Tracciato 3606",
    d: "M39.63,27.629c-2.484,7.324-10.108,14.935-18.172,12.2S7.948,25.045,10.433,17.721,19.041,5.436,27.1,8.171,42.114,20.305,39.63,27.629",
    transform: "translate(6.213 4.685)",
    fill: "#00335f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3607",
    "data-name": "Tracciato 3607",
    d: "M32.458,25.884c-.97,5.4-6.792,11.385-13.2,9.211S8.3,23.278,10.276,17.459,17.34,7.768,23.747,9.942s9.8,9.895,8.711,15.942",
    transform: "translate(6.203 5.899)",
    fill: "#00447d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3608",
    "data-name": "Tracciato 3608",
    d: "M19.13,15.283a2.811,2.811,0,1,1-2.811-2.811,2.811,2.811,0,0,1,2.811,2.811",
    transform: "translate(8.541 7.886)",
    fill: "#fff"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_554",
    "data-name": "Raggruppa 554",
    transform: "translate(30 103)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_553",
    "data-name": "Raggruppa 553",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_552",
    "data-name": "Raggruppa 552",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_551",
    "data-name": "Raggruppa 551",
    clipPath: "url(#clip-path-33)"
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3609",
    "data-name": "Tracciato 3609",
    d: "M95.1,47.546A47.548,47.548,0,1,0,47.55,95.091,47.545,47.545,0,0,0,95.1,47.546",
    transform: "translate(0 0.001)",
    fill: "#fdb813"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_526",
    "data-name": "Raggruppa 526",
    transform: "translate(0 0.001)",
    opacity: 0.6,
    style: {
      mixBlendMode: "overlay",
      isolation: "isolate"
    }
  }, _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_525",
    "data-name": "Raggruppa 525",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_524",
    "data-name": "Raggruppa 524",
    clipPath: "url(#clip-path-33)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_523",
    "data-name": "Raggruppa 523",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_522",
    "data-name": "Raggruppa 522",
    clipPath: "url(#clip-path-36)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_288",
    "data-name": "Rettangolo 288",
    width: 95.095,
    height: 95.095,
    transform: "translate(0 -0.001)",
    fill: "url(#radial-gradient)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_550",
    "data-name": "Raggruppa 550",
    transform: "translate(1.1 13.871)",
    opacity: 0.4,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_549",
    "data-name": "Raggruppa 549"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_548",
    "data-name": "Raggruppa 548",
    clipPath: "url(#clip-path-37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3611",
    "data-name": "Tracciato 3611",
    d: "M20.783,32.1h0Zm0,0Zm0,0h0Zm0,0v0Zm0,0h0Zm0,0h0Zm0,0Zm0,0,0,0Zm0,0Zm0,0h0Zm0,0Zm0,0,0,0Zm0,0Zm0,0Zm0,0h0Zm0,0v0Zm0,0h0Zm0,0Zm0,0h0Zm0,0v0Zm0,0h0Zm0,0Zm0,0,0,0h0Zm0,0Zm0,0Zm0,0h0Zm0,0v0Zm0,0h0Zm0,0Zm0,0h0Zm0,0v0Zm-.173.08Zm0,0v0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0,0,0v0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0v0Zm0,0h0Zm0,0Zm0,0Zm0,0h0Zm0,0,0,0Zm0,0Zm0,0h0Zm0,0Zm0,0,0,0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0v0Zm0,0h0Zm0,0Zm0,0h0Zm0,0v0Zm0,0h0Zm0,0Zm-.105.046-.063.021.063-.025Zm-.1.034-.063.021Zm-.1.034-.067.017.072-.021Zm-.257.055h0Zm0,0h0Zm0,0h0m0,0,0,0Zm.008,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm.008,0,0,0Zm0,0h0Zm0,0h0Zm.008,0h0Zm0,0,0,0Zm0,0h0Zm0,0h0Zm.008,0h0Zm0,0h0m0,0v0Zm.008,0h0Zm0,0h0Zm.008,0-.008,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm.008,0,0,0Zm0,0h0Zm0,0h0Zm.008,0,0,0Zm0,0h0Zm0,0h0Zm.008,0h0Zm0,0,0,0,0,0m-.253.038Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0,0,0Zm0,0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0h0Zm0,0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0v0Zm0,0h0Zm0,0Zm-.147.008Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm-.135,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0v0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm-.105-.008-.025,0Zm.025,0-.025,0,.029,0ZM19.8,32.26h0Zm0,0Zm0,0h0Zm0,0Zm0,0,0,0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0,0,0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0,0,0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm-.067-.017-.067-.021Zm-.067-.021-.059-.025Zm-.114-.059h0Zm0,0Zm0,0v0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0,0,0Zm0,0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0,0,0Zm0,0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0,0,0Zm0,0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0v0Zm0,0h0Zm0,0Zm0,0Zm0,0Zm-.088-.055v0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0v0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0Zm0,0v0Zm0,0h0Zm0,0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0v0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0Zm0,0,0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm-.08-.059Zm0,0h0Zm0,0Zm0,0Zm0,0Zm0,0v0Zm0,0h0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0v0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0v0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0v0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm-.072-.063Zm0,0Zm0,0,0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0,0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0,0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0h0Zm0,0v0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm-.055-.055Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0v0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0h0Zm0,0h0Zm0,0Zm0,0ZM20.981,32l.013-.008-.105.055L20.981,32m.219-.126c-.059.034-.143.08-.206.118.063-.038.147-.084.206-.118m.215-.139-.215.139.215-.139m.219-.156c-.067.046-.152.11-.219.156.067-.046.152-.11.219-.156m.228-.169-.228.169Zm.228-.19c-.067.059-.16.135-.228.19.067-.055.16-.131.228-.19m.24-.2-.24.2.24-.2m.24-.219c-.072.063-.169.152-.24.219.072-.067.169-.156.24-.219m.244-.236c-.076.072-.173.164-.244.236.072-.072.169-.164.244-.236m.249-.249-.249.249.249-.249m.253-.265-.253.265.253-.265m.257-.274c-.076.08-.177.194-.257.274.08-.08.181-.194.257-.274m.261-.295c-.08.088-.181.206-.261.295.08-.088.181-.206.261-.295m.261-.3c-.08.093-.181.215-.261.3.08-.088.181-.211.261-.3m.265-.316c-.08.093-.185.219-.265.316.08-.1.185-.223.265-.316m.261-.333c-.076.1-.185.232-.261.333.076-.1.185-.232.261-.333m.27-.337-.27.337.27-.337m.265-.354c-.08.105-.19.244-.265.354.076-.11.185-.249.265-.354m.265-.362c-.08.105-.185.253-.265.362.08-.11.185-.257.265-.362m.265-.375c-.08.11-.185.261-.265.375.08-.114.185-.265.265-.375m.261-.383c-.076.114-.181.265-.261.383.08-.118.185-.27.261-.383m.265-.4c-.08.118-.185.278-.265.4.08-.118.185-.278.265-.4m.257-.4c-.076.122-.181.282-.257.4.076-.118.181-.278.257-.4m.257-.409c-.076.122-.181.287-.257.409.076-.122.181-.287.257-.409m.253-.421-.253.421.253-.421m.249-.421c-.072.126-.173.295-.249.421.076-.126.177-.295.249-.421m.249-.434c-.076.131-.173.3-.249.434.076-.131.173-.3.244-.434Zm.236-.434-.24.434.24-.434m.236-.442c-.072.131-.164.308-.236.442.072-.135.164-.312.236-.442m.223-.451-.223.451.223-.451m.219-.447c-.063.135-.152.312-.219.447.067-.135.156-.312.219-.447M28.608,22c.063-.135.139-.32.2-.455-.063.135-.265.59-.2.455-.063.139-.147.316-.215.455C28.461,22.319,28.545,22.138,28.608,22Zm.206-.464.11-.261-.114.27,0-.008m.223-.531,0,.008v0Zm0,.008,0,0Zm0,0v0Zm0,.008,0,0Zm0,0v0Zm0,.008,0,0Zm-.008.013,0-.008v0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,.013v0Zm0,0v0Zm0,.008,0,0Zm0,0v0Zm0,.008v0Zm0,0,0,0Zm0,.008v0Zm0,0,0,0Zm0,0,0,0Zm0,.008v0Zm0,.013,0-.008,0,0Zm0,0,0,0Zm0,.008v0Zm0,0,0,0,0,0m0,.013v0Zm0,0v0m0,0v0Zm0,.013v0m0,0,0,0Zm0,0v0Zm0,.013,0,0-.008.013Zm.194-.476v0m0,.008v0Zm0,0,0,0Zm0,.008v0Zm0,0,0,.008v0Zm0,.008,0,0Zm0,.013v0Zm0,.008,0-.008,0,0Zm0,0v0m0,0v0Zm0,.017,0-.008Zm0,0v0Zm0,0,0,.008v0Zm0,.008,0,0Zm0,0v0Zm0,.008,0,0v0Zm0,0,0,.008,0,0Zm0,.008v0Zm0,.008,0,0Zm0,0v0Zm0,.013v0Zm0,.008,0,0Zm0,.008v0Zm0,0,0,0v0Zm-.008.013,0-.008v0Zm0,0v0Zm0,0,0,.008Zm-.008.013,0,0Zm0,0v0Zm0,.008,0,.008Zm-.008.013,0,0,0,.013Zm.2-.518v0Zm0,.008,0,.008,0,0Zm0,.008,0,.008,0-.008m0,.008v0Zm0,.008,0,.008v0Zm0,.008,0,0Zm-.008.017,0-.008v0Zm0,.008v0Zm0,0,0,0Zm0,.008,0,0,0,0m0,.017v0Zm0,0,0,0,0,0m0,.008,0,0,0,0m0,.008v0m0,.008v0m0,0v0m0,.008,0,.008,0,0Zm0,.008,0,.008,0,0Zm0,.008v0Zm0,.008v0Zm0,.017v0m0,.008,0,0,0,0m0,.008,0,0Zm0,0v0Zm0,.017v0Zm0,.008,0-.008Zm0,0,0,.008Zm0,.017v0Zm0,0,0,.008v-.008Zm0,.008,0,0,0,0m-.008.017,0-.008,0,.013Zm.152-.4.042-.11-.042.114Zm-.042.114.042-.11c-.017.038-.029.08-.042.118Zm.105-.287.076-.206-.076.215Zm.337-1.007-.008.021.008-.021m-.008.021-.008.025.008-.025m-.008.025,0,.021,0-.021m0,.021-.008.025.008-.025m-.008.025-.008.021.008-.021m-.008.021-.008.025.008-.025m-.013.046,0-.021,0,.021m-.008.025.008-.025-.008.025m0,0-.008.025.008-.025m-.008.025,0,.021,0-.021m-.013.046.008-.025-.008.025m0,0-.008.025.008-.025m-.008.025-.008.021.008-.021m-.008.021,0,.025,0-.025m0,.025-.008.021.008-.021m-.008.021-.008.025.008-.025m-.008.025-.008.025.008-.025m-.008.025-.008.021Zm-.008.021-.008.025.008-.025m-.008.025-.008.025.008-.025m-.017.051.008-.025-.008.025m0,.021,0-.021,0,.021m-.008.025.008-.025Zm0,0-.008.025Zm-.017.051.008-.025-.008.025m-.008.021.008-.021-.008.021m0,0-.008.025.008-.025m-.017.051.008-.025Zm0,0-.008.025Zm-.008.025-.008.021.008-.021m-.017.046.008-.025-.017.051.008-.025m.278-.876-.038.135a8.186,8.186,0,0,0,.438-3.4l.013.076a8.209,8.209,0,0,1-.413,3.19m.375-3.392v0Zm0,0v0Zm0,0,0,0Zm0,0Zm0,0v0Zm0,0v0Zm0,.008v0Zm0,0v0Zm0,0,0,0Zm0,0Zm0,0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,.008,0,0Zm0,0v0Zm0,0Zm0,0v0Zm0,.008v0Zm0,0v0Zm0,0,0,0Zm0,0v0Zm0,0v0Zm0,0Zm0,0v0Zm0,.008v0Zm0,0,0,0Zm0,.008v0Zm0,0v0Zm0,0v0Zm0,0Zm0,0v0Zm-.025-.139-.025-.093.025.1Zm-.063-.215v0Zm0,0Zm0,0Zm0,0v0Zm0,0Zm0,0,0,0v0Zm0,0Zm0,0Zm0,0v0Zm0,0Zm0,0v0Zm0,0h0Zm0,0Zm0,0v0Zm0,0Zm0,0v0Zm0,0Zm0,0Zm0,0v0Zm0,0Zm0,0,0,0Zm0,0Zm0,0Zm0,0v0Zm0,0Zm0,0v0Zm0,0h0Zm0,0v0Zm0,0Zm0,0Zm0,0v0Zm0,0Zm-.051-.143Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0v0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0v0Zm0,0Zm0,0Zm0,0Zm-1.475,5.925c.034-.08,3.3-7.922-.257-6.447a6.8,6.8,0,0,0-.839.472C23.337,18.3,19.009,26.348,19.051,30.84c2.153,1.732,7.117-3.974,9.515-9.684",
    transform: "translate(60.128 32.809)",
    fill: "#ff8d23"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_529",
    "data-name": "Raggruppa 529",
    transform: "translate(79.176 47.787)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_528",
    "data-name": "Raggruppa 528"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_527",
    "data-name": "Raggruppa 527",
    clipPath: "url(#clip-path-38)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3612",
    "data-name": "Tracciato 3612",
    d: "M28.4,22.112c-2.828,5.929-8.15,11.8-9.186,9.22a2.953,2.953,0,0,1-.16-.839c3.055,2.465,11.479-9.835,10.863-15.857v0c.906,1.534-.468,5.107-1.1,6.569-.122.274-.282.641-.413.91",
    transform: "translate(-19.051 -14.632)",
    fill: "#ff6523"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_532",
    "data-name": "Raggruppa 532",
    transform: "translate(57.345 51.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_531",
    "data-name": "Raggruppa 531"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_530",
    "data-name": "Raggruppa 530",
    clipPath: "url(#clip-path-39)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3613",
    "data-name": "Tracciato 3613",
    d: "M23.078,19.7c-.83,3.877-6.447,5.672-8.588,2.743-1.6-2.183-.1-6.4,4.319-7.033,3.616-.181,4.673,2.4,4.269,4.29",
    transform: "translate(-13.869 -15.4)",
    fill: "#ff8d23"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_535",
    "data-name": "Raggruppa 535",
    transform: "translate(86.481 30.786)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_534",
    "data-name": "Raggruppa 534"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_533",
    "data-name": "Raggruppa 533",
    clipPath: "url(#clip-path-40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3614",
    "data-name": "Tracciato 3614",
    d: "M24.55,14.054c.16,3.118-1.273,5.6-2.6,4.5-1.589-1.323-1.639-6.557.341-7.851,1.4-.6,2.166,1.6,2.254,3.354",
    transform: "translate(-20.782 -10.596)",
    fill: "#ff8d23"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_538",
    "data-name": "Raggruppa 538",
    transform: "translate(60.82 6.089)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_537",
    "data-name": "Raggruppa 537"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_536",
    "data-name": "Raggruppa 536",
    clipPath: "url(#clip-path-41)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3615",
    "data-name": "Tracciato 3615",
    d: "M18.252,6.732c.6,1.517-.346,2.629-1.74,2.048-1.829-.759-2.381-3.371-1.18-3.948a1.661,1.661,0,0,1,.291-.088c1.226-.11,2.276,1.1,2.629,1.989",
    transform: "translate(-14.695 -4.737)",
    fill: "#ff8d23"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3616",
    "data-name": "Tracciato 3616",
    d: "M8.165,46.28h0l-.051-.021.051.021m-.354-.16h0l-.055-.029,0,0,.051.025m-.388-.2Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0h0Zm0,0h0Zm0,0v0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0Zm0,0h0Zm0,0v0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0Zm0,0v0Zm0,0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0v0Zm0,0h0Zm0,0Zm-.683-.4Zm0,0v0Zm0,0h0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0h0Zm0,0v0Zm0,0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0v0Zm0,0h0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0v0Zm0,0Zm0,0Zm-.341-.232Zm0,0Zm0,0h0Zm0,0Zm0,0v0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0v0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0ZM1.212,37.106Zm0,0Zm0,0v0Zm0,0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0v0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0v0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm-.131-.5-.013-.055.017.059Zm.017.063-.013-.059ZM.93,35.939v0Zm0,.013,0-.013,0,.013m0,.013,0-.013Zm0,.013v0Zm0,.008,0-.008,0,.008m0,.013v0Zm0,.013v0Zm0,.008v0m0,.013,0-.013,0,.013m0,.013,0-.013Zm0,.008v0m0,.013,0-.008,0,.008m0,.013v0Zm0,.008v0Zm0,.013,0-.008,0,.008m0,.013v0Zm0,.013,0-.013,0,.008Zm0,.008v0m0,.013,0-.013,0,.013m0,.013,0-.013v.008Zm0,.008v0m0,.013,0-.013,0,.008Zm0,.013v0Zm0,.008,0-.008,0,.008m0,.013,0-.013,0,.013m0,.013v0m0,.008,0,0,0,0m0,.013,0-.008,0,.008m0,.013v0m0,.008,0,0,0,0m0,.013v0m0,0,0,.013,0-.013m26.08-8.63.017-.118-.017.122Zm.08-.611v0l.008-.072-.008.067m.072-.615v0Zm0,0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,0h0Zm0,0v0Zm0,0v0Zm0,.008v0Zm0,0v0Zm0,0Zm0,0v0Zm0,0v0Zm0,.008v0Zm0,0Zm0,0v0Zm0,0h0Zm0,0v0Zm0,0v0Zm0,0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,0Zm0,0v0Zm0,0v0Zm.063-.636,0-.038,0,.042Zm0,.042,0-.038Zm.051-.6v0Zm0,0Zm0,0v0Zm0,0Zm0,0v0Zm0,0v0Zm0,0Zm0,0Zm0,0v0Zm0,0Zm0,0v0Zm0,0v0Zm0,0h0Zm0,0v0Zm0,0v0Zm0,0Zm0,0Zm0,0v0Zm0,0Zm0,0v0Zm0,0v0Zm0,0Zm0,0v0Zm0,0Zm0,0v0Zm0,0v0Zm0,0Zm0,0v0Zm0,0v0Zm0,0Zm0,0v0Zm.038-.569,0-.1,0,.1ZM27.4,24.3h0v0m.021-.531v0Zm.013-.59v0Zm0,.017v0Zm0-.6v0Zm0,0v0Zm0,0Zm0,0v0Zm0,0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,.008v0Zm0,0v0Zm0,0v0Zm0,.008v0Zm0,0v0Zm0,.008v0Zm0,0v0Zm0,.008v0Zm0,0Zm0,.008v0Zm0,0v0Zm0,0Zm0,0Zm0,0v0Zm0,0v0Zm0,0Zm0,0v0Zm0,.008h0v0Zm0-.657v0Zm0,0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,0Zm0,0v0Zm0,0v0Zm0,0Zm0,0v0Zm0,0Zm0,0v0Zm0,0v0Zm0,.008v0Zm0,0Zm0,0v0Zm0,.008v0Zm0,0Zm0,0v0Zm0,0v0Zm0,0Zm0,0v0Zm0,.008v0Zm0,0Zm0,0v0Zm0,0v0Zm0,0Zm0,0v0Zm0,0Zm0,0Zm0,0v0Zm-.013-.59v0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,.008v0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,0Zm0,0Zm0,0v0Zm0,.008v0Zm0,0v0Zm0,.008v0Zm0,0v0Zm0,.008v0Zm0,0v0Zm0,.008,0,0Zm0,0v0Zm0,0Zm0,.008v0Zm0,0Zm0,0v0Zm0,0Zm0,0Zm0,0v0Zm-.025-.666v0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,.008v0Zm0,0,0,0v0Zm0,0v0Zm0,.008v0Zm0,0Zm0,0v0Zm0,0v0Zm0,.008v0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,.008v0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,0v0Zm-.021-.464-.008-.126.008.131Zm-.046-.674v0Zm0,0,0,0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,.008v0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,0,0,0Zm0,0v0Zm0,.013v0Zm0,0v0Zm0,.008v0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,.008v0Zm0,.008v0Zm0,0v0Zm0,0v0Zm0,.008v0Zm0,0v0Zm0,0,0,0Zm0,0v0Zm0,.013v0Zm0,0v0Zm0,0v0Zm0,0v0Zm0,0v0Zm-.046-.619v0Zm0,0v0Zm0,0v0Zm0,.008v0m0,0v0Zm0,.008v0Zm0,.008v0Zm0,0v0Zm0,0,0,0v0Zm0,0v0Zm0,0v0Zm0,.008v0Zm0,0v0Zm0,.013v0Zm0,0v0Zm0,.008v0Zm0,0v0Zm0,0v0Zm0,.008,0,0Zm0,.008v0Zm0,.008v0Zm0,0h0m0,0v0Zm0,.008v0Zm0,0v0Zm0,.008Zm0,0v0Zm0,.008Zm0,.008,0-.008Zm0,0v0Zm0,0v0Zm0,0v0Zm-.046-.51L27.254,19l.017.181v-.008m-.046-.447-.029-.257c.013.088.021.177.029.265Zm-.055-.489v.008l-.025-.206v0l.025.194m-.055-.426v.008c-.013-.105-.029-.219-.046-.329l0,.013c.013.1.029.206.042.308m-.131-.889-.063-.367c.025.131.046.261.067.392l0-.025m.059.4c-.017-.126-.034-.249-.055-.375.021.135.042.265.059.4l0-.025M.55,33.642l.013.114-.042-.413-.008-.029c.013.1.025.232.038.329m.025.223.013.088c0-.059-.017-.139-.025-.2Zm.282,1.715c.017.1.042.223.063.316-.1-.582-.232-1.361-.333-1.943l0,.017c.042.316.126.91.265,1.61M24.806,9.48l.013.025-.013-.029Zm.013.025.211.472-.16-.375-.051-.1m.211.472.135.3-.029-.076c-.029-.067-.072-.156-.105-.223m.135.3.185.464-.118-.32-.067-.143m.185.464.143.367-.051-.139c-.025-.067-.063-.16-.093-.228m.143.367.164.464-.088-.27c-.021-.059-.055-.135-.076-.194m.164.464.143.417-.063-.206-.08-.211m.143.417.147.468-.063-.223-.084-.244m.147.468.143.472-.08-.287c-.017-.059-.042-.131-.063-.185m.143.472.131.464-.042-.173C26.154,13.129,26.116,13.015,26.091,12.927Zm-3.173,11.93c2.094-6.662,2.28-14.589,1.572-16.017C22.716,5.75,21.355,5.156,19.479,4.6,6.918,2.995-2.113,23.167.816,34.485c3.911,11.327,15.056,6.422,20.522-5.508a39.561,39.561,0,0,0,1.58-4.121m3.3-11.466.139.535-.093-.388c-.013-.042-.029-.105-.046-.147m.139.535.114.451-.025-.118c-.025-.1-.063-.232-.088-.333m.114.451.143.645-.114-.539-.029-.105m.143.645.088.388-.013-.059c-.021-.1-.051-.232-.076-.329m.088.388.206,1.079c-.063-.324-.131-.759-.206-1.079",
    transform: "translate(-0.26 0.635)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_541",
    "data-name": "Raggruppa 541",
    transform: "translate(0.252 10.114)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_540",
    "data-name": "Raggruppa 540"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_539",
    "data-name": "Raggruppa 539",
    clipPath: "url(#clip-path-42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3617",
    "data-name": "Tracciato 3617",
    d: "M26.384,26.617C22.815,42.124,9.748,48.584,3.085,38.138A20.152,20.152,0,0,1,.321,29.529c2.941,11.39,12.7,8.967,18.824-.632,2.714-4.26,5.866-11.74,5.474-23.206a34.53,34.53,0,0,1,1.766,20.926",
    transform: "translate(-0.321 -5.694)",
    fill: "#ff8d23"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3618",
    "data-name": "Tracciato 3618",
    d: "M17.31,25.6h0Zm0,0h0Zm.008,0h0m.008,0h0Zm0,0,0,0Zm.008,0h0m.008,0h0Zm0,0h0Zm.008,0h0Zm0,0h0Zm.008,0h0Zm.008,0-.008,0Zm0,0h0Zm.008,0h0Zm0,0h0Zm.008,0h0Zm.008,0h0Zm0,0h0Zm.008,0h0Zm.008,0h0Zm0,0h0Zm.008,0-.008,0,.008,0m.008,0h0Zm0,0h0Zm.008,0h0Zm0,0h0Zm.008,0h0Zm.008,0h0Zm0,0h0Zm.008,0h0m.008,0h0m-.527-.042h0Zm0,0h0Zm.008,0h0Zm0,0h0Zm.008,0h0Zm0,0,0,0Zm0,0h0Zm.008,0h0Zm0,0h0Zm.008,0h0Zm0,0h0m0,0h0Zm.008,0,0,0,0,0m0,0h0Zm.008,0h0Zm0,0h0Zm.008,0h0Zm0,0h0Zm0,0h0Zm.008,0,0,0Zm0,0h0Zm.008,0h0Zm0,0h0Zm.008,0h0Zm0,0h0Zm.008,0h0Zm0,0,0,0Zm.008,0h0Zm0,0h0Zm0,0h0Zm.008,0h0Zm-.333-.038c-.059,0-.114-.013-.173-.021l.181.025,0,0Zm-.48-.072h0Zm.008,0,0,0Zm0,0h0Zm.008,0h0Zm0,0h0Zm0,0h0Zm0,0,0,0Zm.013,0h0Zm0,0h0Zm0,0h0Zm0,0,0,0Zm0,0h0Zm.013,0h0Zm0,0h0Zm.008,0h0Zm.008,0-.008,0,0,0Zm0,0h0Zm.008,0h0Zm0,0h0Zm.008,0h0Zm0,0Zm.008,0h0Zm0,0h0Zm0,0h0Zm.008,0-.008,0Zm0,0h0Zm0,0h0Zm.008,0h0Zm0,0h0Zm.008,0h0Zm0,0,0,0Zm0,0h0Zm-.468-.088h0Zm0,0h0Zm.008,0-.008,0Zm0,0h0Zm0,0h0Zm0,0,0,0Zm0,0Zm.008,0h0Zm0,0h0Zm0,0h0Zm0,0,0,0Zm.008,0h0Zm0,0h0Zm0,0h0m0,0h0Zm0,0h0Zm0,0h0Zm.008,0,0,0,0,0m0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm.008,0,0,0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0,0,0Zm.008,0h0Zm0,0h0Zm0,0h0Zm0,0h0l.008,0Zm-.438-.093h0Zm0,0h0Zm0,0h0Zm0,0,0,0Zm.008,0h0Zm0,0h0Zm0,0,0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0,0,0Zm0,0h0Zm0,0h0Zm0,0,0,0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0,0,0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0,0,0Zm0,0h0Zm0,0h0Zm0,0h0Zm0,0v0Zm0,0h0Zm0,0Zm0,0h0Zm-.569-.147Zm0,0v0Zm0,0h0Zm0,0Zm0,0h0Zm0,0h0Zm0,0Zm0,0Zm0,0,0,0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0,0,0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0v0Zm0,0h0Zm0,0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0,0,0Zm-.346-.105,0,0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0v0Zm0,0h0Zm0,0Zm0,0h0Zm0,0h0Zm0,0Zm0,0Zm0,0,0,0Zm.008,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0,0,0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0,0,0Zm0,0Zm0,0h0Zm0,0h0Zm0,0Zm0,0h0Zm0,0v0Zm0,0h0Zm-.346-.118h0Zm0,0Zm0,0,0,0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0,0,0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0Zm0,0v0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0h0Zm0,0Zm0,0v0Zm0,0h0Zm0,0Zm-.312-.118v0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0h0Zm0,0v0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0h0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0Zm0,0h0Zm3.139.653h0m.038,0-.038,0,.038,0m.042,0h0m.042,0-.042,0,.042,0m.038,0h0m.042,0h0m.042,0h0m.042,0-.042,0,.042,0m.6-.008c-.181,0-.421,0-.6.008.181,0,.421-.008.6-.008m.6-.042-.6.042.6-.042m.59-.08c-.177.025-.413.055-.59.08.177-.025.413-.055.59-.08m.577-.11c-.173.034-.4.08-.577.11.173-.029.4-.076.577-.11m.569-.139-.569.139.569-.139m.556-.173c-.164.051-.388.118-.556.173.169-.055.392-.122.556-.173M22,24.877l-.544.206L22,24.877m.523-.232c-.156.072-.367.164-.523.232.156-.067.367-.16.523-.232m.51-.257c-.152.076-.354.181-.51.257.156-.076.358-.181.51-.257m.493-.291c-.147.088-.346.2-.493.291.147-.088.346-.2.493-.291m.468-.312-.468.312.468-.312m.451-.337-.451.337.451-.337m.43-.362-.43.362.43-.362m.4-.383c-.122.118-.282.27-.4.383.122-.114.282-.265.4-.383m.379-.4c-.114.118-.265.282-.379.4.114-.118.265-.282.379-.4m.358-.426c-.105.126-.249.295-.358.426.11-.131.253-.3.358-.426m.333-.442c-.1.131-.232.308-.333.442.1-.135.232-.312.333-.442m.3-.459c-.088.135-.211.32-.3.459.093-.139.215-.324.3-.459m.278-.476c-.08.139-.194.333-.278.476.084-.143.2-.337.278-.476m.253-.493-.253.493.253-.493M27.4,19.5l-.223.506L27.4,19.5m.194-.518c-.059.156-.135.362-.194.518.059-.156.135-.362.194-.518m.164-.527c-.051.156-.114.367-.164.527.051-.16.114-.371.164-.527m.135-.544c-.038.164-.093.379-.135.544.042-.164.1-.379.135-.544m.11-.548c-.034.164-.076.383-.11.548C27.929,17.747,27.971,17.528,28,17.363Zm.076-.556c-.025.169-.055.388-.076.556.021-.169.051-.388.076-.556m.046-.565c-.013.169-.034.4-.046.565.013-.169.034-.4.046-.565m.017-.569c0,.173-.013.4-.017.569,0-.169.013-.4.017-.569m-.008-.573c0,.173.008.4.008.573,0-.173-.008-.4-.008-.573m-.042-.577.042.577-.042-.577m-.067-.582c.025.173.046.409.067.582-.042-.35-.11-.813-.169-1.163.029.177.076.409.1.582m-.169-.919,0,.008,0-.008m0,.008v0Zm0,.013,0,.008,0,0Zm0,.008v0m0,.013,0,.008,0-.008m0,.021v0Zm0,.008,0-.008,0,.008m0,.013v0Zm0,0,0,.008,0-.008m0,.021v0Zm0,0,0,.008,0-.008m0,.021v0m0,0,0,.008Zm0,.021v0Zm0,.008,0-.008,0,.008m0,0v0Zm0,.021v0m0,0v0Zm0,.013,0,.008v0Zm0,.021v0Zm0,0,0,.008,0-.008m0,.008v0m0,.013,0,.008,0-.008m0,.008v0m0,.013v0m0,.021v0Zm0,0,0,.013V13.3Zm0,.021v0Zm0,.013,0-.013,0,.008Zm0,.008,0-.008v0Zm0,0v0m0,.013v0m-.147-.67v0Zm0,0,0,0Zm0,.008v0Zm0,.008,0,.008,0,0Zm0,.008v0Zm0,.013,0,0,0,0m0,.008v0m0,.008v0Zm0,0,0,.008v0Zm0,.017v0Zm0,0,0,0,0,0m0,.013v0Zm0,0v0Zm0,.017v0Zm0,.008,0-.008v0Zm0,0v0m0,.017v0Zm0,0,0,0Zm0,0v0Zm0,.017,0,0,0,0m0,0v0Zm0,.008v0Zm0,.008,0,0Zm0,.008v0Zm0,.008,0,0Zm0,.013v0Zm0,0v0Zm0,.017v0Zm0,.008v0Zm0,.008v0Zm0,0v0Zm0,0,0,.008Zm-.152-.607v0Zm0,.008,0,.008Zm0,.008,0,.008Zm0,.008v0m0,.008,0,.008,0,0Zm0,.017v0m0,.008,0-.008Zm0,.008v0Zm0,0,0,.008,0,0Zm0,.017v0Zm0,0,0,.008Zm0,.017v0Zm0,0,0,.008Zm.008.017,0-.008v.008Zm0,.008v0Zm0,0,0,.008,0,0Zm0,.017v0m0,0,0,.008,0,0Zm0,.008v0Zm0,.017,0-.008Zm0,0v0Zm0,.008,0,.008Zm0,.008v0Zm0,.008,0,.013v-.008Zm0,.013v0Zm0,.017v0Zm0,0,0,.008Zm0,.017v0Zm0,.008v0Zm0,.008,0-.008,0,0Zm0,0,0,0Zm0,.008v0m-.19-.662,0,.013,0-.013m0,.013,0,.008,0,0Zm0,.008,0,.013,0-.013m0,.013v0Zm0,.008v.008l0-.008Zm0,.021,0-.008,0,.008m0,.013,0-.008,0,.008m0,.008v0m0,0,0,.008,0-.008m.008.021,0-.008,0,.008m0,0,0,.013,0-.008Zm.008.021,0,0,0,0m0,0v0m0,.021,0-.008,0,.008m0,.013,0-.008,0,.008m0,0v0m0,.021,0-.013,0,.008Zm0,0,0,.008,0-.008m0,.008,0,.013,0-.008Zm0,.021v0m0,0,0,.008,0-.008m0,.013,0,.008,0-.008m0,.008,0,.013,0-.008Zm0,.013,0,.008,0-.008m0,.008v0Zm0,.021,0-.008,0,.008m0,0v0m0,.021v0m0,.013,0-.013Zm0,.008,0,0,0,0m0,0v0m0,.013,0,.008,0-.008m-.2-.653,0,.008Zm0,.008v0m0,.008,0,.008,0,0Zm0,.008v0m0,.013,0,0,0,0m.008.017,0,0,0,0m0,.013,0-.013v.008Zm0,.008v0Zm0,0,0,.008,0-.008m.008.021,0-.008Zm0,0v0m0,.017v0m0,0,0,.008,0-.008m.008.021,0-.008,0,0Zm0,.008,0,0,0,0m0,0v0Zm0,.021v0Zm0,0,0,.008Zm0,.008,0,.008Zm.008.021,0-.008v0Zm0,0v0m0,.008,0,.013,0-.008Zm0,.013,0,.008,0-.008m0,.008v0Zm0,.008,0,.008,0-.008m.008.021,0-.008,0,0Zm0,0v0Zm.008.021,0-.013v.008Zm0,.008v0Zm0,.008,0,0,0,0m0,0,0,.013,0-.008Zm0,.013v0m-.122-.367-.1-.291c.034.1.072.2.105.3Zm-.19-.518c.025.063.059.147.08.211a15.519,15.519,0,0,0-3.439-5.406l.122.126a15.649,15.649,0,0,1,3.236,5.069M23.812,5.741l-.088-.093.093.093Zm-.2-.194h0l-.029-.025h0l.021.025m1.753,6.628c-.114-2.162-.965-9.182-7.088-8.874C10.69,4.688,5.266,17.92,10.841,21.455c6,3.805,14.985-.59,14.525-9.279",
    transform: "translate(26.38 -3.291)",
    fill: "#fa0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_544",
    "data-name": "Raggruppa 544",
    transform: "translate(36.04 1.424)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_543",
    "data-name": "Raggruppa 543"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_542",
    "data-name": "Raggruppa 542",
    clipPath: "url(#clip-path-43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3619",
    "data-name": "Tracciato 3619",
    d: "M27.246,13.436a9.987,9.987,0,0,1-15.819,9.191,9.409,9.409,0,0,1-2.613-3.169c6.477,5.482,16.165.32,15.705-8.369A14.49,14.49,0,0,0,21.8,3.63a14.968,14.968,0,0,1,5.276,8.643c.051.35.135.813.169,1.163",
    transform: "translate(-8.813 -3.628)",
    fill: "#ff8d23"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_547",
    "data-name": "Raggruppa 547",
    transform: "translate(28.76 36.232)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_546",
    "data-name": "Raggruppa 546"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_545",
    "data-name": "Raggruppa 545",
    clipPath: "url(#clip-path-44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3620",
    "data-name": "Tracciato 3620",
    d: "M16.963,17.905A4.8,4.8,0,0,1,8.4,20.4c-2.756-3.278-1.049-8.647,3.793-8.512a5.437,5.437,0,0,1,4.766,6.013",
    transform: "translate(-7.086 -11.891)",
    fill: "#ff8d23"
  }))))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQ4);
export default __webpack_public_path__ + "static/media/q4.15434a7e83819b2af4a4892ce4cdf506.svg";
export { ForwardRef as ReactComponent };